export const ENDPOINTS = {
  AUTH_TOKEN: 'auth/token/',
  AUTH_SESSION: 'auth/session/',
  GET_LAND_HARVEST: 'dashboard/land-area/harvest/cotton-region-totals/',
  GET_HARVEST_REGION_STATS: 'dashboard/harvest/region-stats/',
  GET_HARVEST_FARMER_STATS: 'dashboard/harvest/farmer-stats/',
  GET_LAND_HARVEST_CONTRACT: 'dashboard/harvest/region-contracts/',
  GET_LAND_HARVEST_LOADS: 'dashboard/harvest/region-loads/',
  GET_HARVEST_PLACES_REGION_STATS: 'dashboard/harvest/places/region-stats/',
  GET_HARVEST_PLACE_RETRIEVE: 'dashboard/harvest/places/retrieve/',
  GET_INSURANCE_CHART: 'dashboard/insurance/chart/',
  GET_INSURANCE_STATS: 'dashboard/insurance/stats/',
  GET_INSURANCE_STATS_BREAKDOWN: 'dashboard/insurance/stats/breakdown/',
  GET_INSURANCE_CONTRACT_BY_PLANT: 'dashboard/insurance/contract-by-plant/',
  GET_INSURANCE_CONTRACT_BY_REGION: 'dashboard/insurance/contract-by-region/',
  GET_BURSE_COTTON_INFO: 'dashboard/burse/cotton-info/',
  GET_BURSE_FUEL_INFO: 'dashboard/burse/fuel-info/',
  GET_PLANTED_SEED_TYPES: 'dashboard/land-area/planted-seed-types/',
  GET_PLANTED_SEED_INFO: '/dashboard/land-area/info/',
  GET_PLANTED_SEED_INFO_COMPANIES: '/dashboard/land-area/info/companies/',
  GET_PLANTED_SEED_INFO_REGIONS: '/dashboard/land-area/info/regions/',
  GET_MINERAL_INFO: '/dashboard/burse/mineral-info/',
  GET_REGIONS: '/tools/regions/',
  GET_UZ_COSMOS_INFO: '/dashboard/land-area/uz-cosmos/info/',
  GET_MONTH_INFO: '/dashboard/burse/month-info/',
  GET_MATERIAL_CONTROL: '/dashboard/material-resource/chemicals/',
  GET_CHEMICAL_RESERVE: '/dashboard/material-resource/quarantine/',
  GET_REGION_INFO: '/dashboard/land-area/info/by-region/',
  GET_DISTRICT_INFO: '/dashboard/land-area/info/by-district/',
  GET_MONITORING: '/dashboard/monitoring/region-totals/',
  GET_COSMIC_MONITORING: '/dashboard/cosmic-monitoring/',
  GET_COSMIC_MONITORING_DETECTIONS: '/dashboard/cosmic-monitoring/detections/',
  GET_GRAIN_COSMIC_COMPARISON_REGION_SUMMARY:
    '/dashboard/cosmic-monitoring/grain/cosmic-comparison/region-summary/',
  GET_GRAIN_COSMIC_COMPARISON_DOWNLOAD:
    '/dashboard/cosmic-monitoring/grain/cosmic-comparison/download/',
  GET_GRAIN_UNDERPLANTED_REGION_SUMMARY:
    '/dashboard/cosmic-monitoring/grain/underplanted/region-summary/',
  GET_GRAIN_UNDERPLANTED_DOWNLOAD:
    '/dashboard/cosmic-monitoring/grain/underplanted/download/',
  GET_GRAIN_UNREGISTERED_OWNER_REGION_SUMMARY:
    '/dashboard/cosmic-monitoring/grain/unregistered-owner/region-summary/',
  GET_GRAIN_UNREGISTERED_OWNER_DOWNLOAD:
    '/dashboard/cosmic-monitoring/grain/unregistered-owner/download/',
  GET_GRAIN_EXCESS_CREDIT_REGION_SUMMARY:
    '/dashboard/cosmic-monitoring/grain/excess-credit/region-summary/',
  GET_GRAIN_EXCESS_CREDIT_DOWNLOAD:
    '/dashboard/cosmic-monitoring/grain/excess-credit/download/',
  GET_PLANTED_SEED_TYPES_BY_REGION:
    '/dashboard/land-area/planted-seed-types/by-region/',
  GET_PLANTED_SEED_TYPES_BY_DISTRICT:
    '/dashboard/land-area/planted-seed-types/by-district',
  GET_BANK_CREDIT_INFO: '/dashboard/bank/credit-balance/',
  GET_BANK_CARDS_INFO: '/dashboard/bank/necessary-for-cultivation/',
  GET_BANK_PREFERENTIAL_CREDIT_CONSUMPTION:
    '/dashboard/bank/preferential-credit-consumption/',
  GET_BANK_PREFERENTIAL_CREDIT_CONSUMPTION_EXPORT:
    '/dashboard/bank/preferential-credit-consumption/export/',
  GET_BANK_PAYMENT_BY_BANKS: '/dashboard/bank/payment-by-banks/',
  GET_BANK_ALLOCATED_TO_BANKS: '/dashboard/bank/amount-allocated-to-banks/',
  GET_ACTIONS_SUMMARY: '/dashboard/agro-monitoring/actions-summary/',
  GET_PROJECTS_AREA_BY_REGIONS:
    '/dashboard/agro-monitoring/projects-area-by-regions/',
  GET_BANK_LOAN_SUMMARY: '/dashboard/bank/credit-contracts/bank-level/',
  GET_COPERATIONS_EXCEL: '/dashboard/land-area/cooperations/export/',
  GET_FARMERS_EXCEL: '/dashboard/land-area/farmers/export/',
  GET_CLUSTERS_EXCEL: '/dashboard/land-area/clusters/export/',
  GET_BANK_SUMMARY: '/dashboard/bank-summary/',
  GET_BANK_SUMMARY_WITH_CREDIT: '/dashboard/bank-summary/with-credit/',
  GET_BANK_REGIONS: '/dashboard/bank-summary/regions/',
  GET_BANK_REGIONS_EXCEL: '/dashboard/bank-summary/regions/export/',
  GET_BANK_SUMMARY_EXPORT: '/dashboard/bank-summary/export/',
  GET_BANK_REGIONS_BY_BANK: '/dashboard/bank-summary/{bank}/regions/',
  GET_BANK_REGIONS_BY_BANK_EXPORT:
    '/dashboard/bank-summary/{bank}/regions/export/',
  GET_BANK_REGIONS_BY_BANK_DISTRICTS:
    '/dashboard/bank-summary/{bank}/regions/{region_id}/districts/',
  GET_BANK_REGIONS_BY_BANK_DISTRICTS_EXPORT:
    '/dashboard/bank-summary/{bank}/regions/{region_id}/districts/export/',
  GET_BANK_TRANSACTION_SUMMARY: '/dashboard/bank/transaction-summary/',
  GET_BANK_TRANSACTION_SUMMARY_EXPORT:
    '/dashboard/bank/transaction-summary/export/',
  GET_BANK_TRANSACTION_SUMMARY_BY_REGION:
    '/dashboard/bank/transaction-summary/by-region/',
  GET_BANK_TRANSACTION_SUMMARY_BY_DISTRICT:
    '/dashboard/bank/transaction-summary/by-district/',
  GET_BANK_TRANSACTION_SUMMARY_BY_SIGNER_EXPORT:
    '/dashboard/bank/transaction-summary/by-signer/export/',
  GET_MATERIAL_RESOURCE_CHEMICALS_INFO:
    '/dashboard/material-resource/chemicals/info/',
  GET_PREFERENTIAL_CREDIT_SCHEDULE_BY_BANK: '/dashboard/bank/credits/by-bank/',
  GET_PREFERENTIAL_CREDIT_SCHEDULE_BY_REGION:
    '/dashboard/bank/credits/by-region/',
  GET_PREFERENTIAL_CREDIT_SCHEDULE_BY_DISTRICT:
    '/dashboard/bank/credits/by-district/',
  GET_REGION_AND_BANK_CREDITS: '/dashboard/bank/credits/by-region-and-bank/',
  GET_DISTRICT_AND_BANK_CREDITS:
    '/dashboard/bank/credits/by-district-and-bank/',
  GET_REGION_AND_BANK_CREDITS_EXPORT:
    '/dashboard/bank/credits/by-region-and-bank/export/',
  GET_DISTRICT_AND_BANK_CREDITS_EXPORT:
    '/dashboard/bank/credits/by-district-and-bank/export/',
  GET_WATER_MANAGEMENT_REGIONS: '/dashboard/mip/water-usage/regions/',
  GET_WATER_MANAGEMENT_REGIONS_EXCEL:
    '/dashboard/mip/water-usage/regions/export/',
  GET_WATER_MANAGEMENT_DISTRICTS: '/dashboard/mip/water-usage/districts/',
  GET_WATER_MANAGEMENT_DISTRICTS_EXCEL:
    '/dashboard/mip/water-usage/districts/export/',
  GET_ELECTRIC_ENERGY: '/dashboard/mip/electricity-accounts/',
  GET_ELECTRIC_ENERGY_EXPORT: '/dashboard/mip/electricity-accounts/export/',
  GET_SERVICES_STATS: '/dashboard/bank/services/stats/',
  GET_SERVICE_USAGE_BY_MONTH: '/dashboard/bank/services/usage-by-month/',
  GET_FINISHED_APPLICATION_BY_DISTRICT:
    '/dashboard/bank/services/finished-application-by-district/',
  GET_FINISHED_APPLICATION_BY_REGION:
    '/dashboard/bank/services/finished-application-by-region/',
  GET_USAGE_BY_MONTH: '/dashboard/bank/services/usage-by-month/',
  GET_VISITS_BY_MONTH: '/dashboard/bank/services/visits-by-month/',
  GET_MATERIAL_RESOURCE_TRANSPORT: '/dashboard/material-resource/transport/',
  GET_SEEDS_APPLICATIONS_COUNT: '/dashboard/seeds/count/applications/',
  GET_SEEDS_DIFFERENCE_BY_YEAR: '/dashboard/seeds/difference/by-year/',
  GET_SEEDS_APPLICATIONS_BY_REGION:
    '/dashboard/seeds/count/applications/by-region/',
  GET_SEEDS_APPLICATIONS_BY_REGION_EXPORT:
    '/dashboard/seeds/count/applications/by-region/export/',
  GET_SUBSIDIYA_APPLICATIONS: '/dashboard/subsidiya/applications/',
  GET_SUBSIDIYA_SERVICES: '/dashboard/subsidiya/by-service/',
  GET_SUBSIDIYA_SUMMARY: '/dashboard/subsidiya/summary/',
  GET_SUBSIDIYA_TASKS_BY_STATUS: '/dashboard/subsidiya/tasks-by-status/',
  GET_SUBSIDIYA_TASKS_BY_DATE: '/dashboard/subsidiya/tasks-by-date/',
  GET_HARVEST_GRAIN_COUNT: '/dashboard/harvest/companies/grain/count/',
  GET_HARVEST_GRAIN_CONTRACT_TOTALS:
    '/dashboard/harvest/grain-contracts/totals/',
  GET_HARVEST_GRAIN_SIGNED_PK10_BY_REGION:
    '/dashboard/harvest/grain/signed-pk10/by-region/',
} as const;
